export default __webpack_public_path__ + "static/media/newly.f9e8e797.svg";